import { getStationCode } from './networkUtil';
import { getShiftPlanConfiguration } from '../handler/parentDataHandler';
import { SSD_FEATURE_FLAGS_LIST } from './constants';

const FEATURE_FLAG = 'FEATURE_FLAG';

export async function getShiftPlanConfigurationResult() {
  const configurationNames = [
    SSD_FEATURE_FLAGS_LIST.narrowWindowsEnabled,
    SSD_FEATURE_FLAGS_LIST.atropsVolumeCapacityUnitsOverrideEnabled
  ].join(',');
  const request = {
    operationType: 'get',
    queryParams: `configurationNames=${configurationNames}&node=${getStationCode()}`
  };
  try {
    return await getShiftPlanConfiguration(request);
  } catch (error) {
    console.error('getShiftPlanConfigurationResult: Error', error);
    return { status: 500, data: {} };
  }
}

export async function fetchFeatureFlagStatuses() {
  try {
    const result = await getShiftPlanConfigurationResult();
    if (result.status === 200) {
      const featureFlags = Object.fromEntries(
        Object.entries(result.data.configurations)
          .filter(([_, value]) => value.type === FEATURE_FLAG)
          .map(([key, value]) => [key, { featureFlagEnabled: value.featureFlagEnabled }])
      );
      return featureFlags;
    }
    console.warn('fetchFeatureFlagStatuses: Non-200 status', result.status);
    return {};
  } catch (error) {
    console.error('fetchFeatureFlagStatuses: Error', error);
    return {};
  }
}
